import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  constructor(
    private http: HttpClient,
    private zone: NgZone
  ) {}

  urlApiManagement = environment.urlApiManagement;

  getMenus() {
    const url = `${this.urlApiManagement}/api/v1/menus`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('getMenus()')));
  }

  setMenu(menu: string) {
    const url = `${this.urlApiManagement}/api/v1/menus/menu-config`;
    const body = {
      menu: menu
    };
    return this.http.post(url, body).pipe(catchError(this.handleError('setMenu()')));
  }

  handleError(error: any) {
    if (!(error instanceof HttpErrorResponse)) {
      return (error = error.rejection);
    }

    this.zone.run(() => console.log('Message: ', error?.message, 'Error: ', error?.status));

    return console.error('Error from global error handler', error);
  }
}
